import * as yup from 'yup';
import dayjs from 'dayjs';
import { ERROR_MESSAGES } from '../constants/error-messages';
import { digitRegex, spaceRegex, specialCharRegex, textLowerCaseRegex, textUpperCaseRegex } from '../constants/regex';

export const passwordValidation = yup
    .string()
    .required(ERROR_MESSAGES.REQUIRED_FIELD_MISSING)
    .min(8, ERROR_MESSAGES.PASSWORD_CHAR_LIMIT)
    .max(20, ERROR_MESSAGES.PASSWORD_CHAR_LIMIT)
    .matches(textLowerCaseRegex, ERROR_MESSAGES.PASSWORD_LOWERCASE)
    .matches(textUpperCaseRegex, ERROR_MESSAGES.PASSWORD_UPPERCASE)
    .matches(digitRegex, ERROR_MESSAGES.PASSWORD_DIGIT)
    .matches(spaceRegex, ERROR_MESSAGES.PASSWORD_NO_SPACES)
    .matches(specialCharRegex, ERROR_MESSAGES.PASSWORD_SPECIAL_CHAR);

export const confirmPasswordValidation = (key: string) =>
    yup
        .string()
        .required(ERROR_MESSAGES.REQUIRED_FIELD_MISSING)
        .oneOf([yup.ref(key)], ERROR_MESSAGES.PASSWORD_DO_NOT_MATCH);

export const Phone = (schema: yup.StringSchema, customError?: string) =>
    schema
        .trim()
        .matches(/^[0-9]{3}-[0-9]{3}-[0-9]{4}$/, customError || ERROR_MESSAGES.INVALID_PHONE_NUMBER)
        .min(12, customError || ERROR_MESSAGES.INVALID_PHONE_NUMBER);

export const PhoneAndRequired = (schema: yup.StringSchema, customError?: string) => Phone(schema, customError).required(customError || ERROR_MESSAGES.REQUIRED_FIELD_MISSING);

export const isNumberZeroOrGreater = (value: number | undefined) => {
    return typeof value === 'number' && value >= 0;
};

export const isNumberGreaterThanZero = (value: number | undefined) => {
    return typeof value === 'number' && value > 0;
}

export const dateOfBirthSchema = yup.string()
    .test('is-month-field-valid', 'Invalid month. Please enter the correct month.', value => {
        if (!value) return false;
        const parts = value.split('/');
        const month = parts?.[0];
        return /^(0[1-9]|1[0-2])$/.test(month);
    })
    .test('is-day-field-valid', 'Invalid day. Please enter the correct day', value => {
        if (!value) return false;
        const parts = value.split('/');
        const day = parts?.[1];
        return /^(0[1-9]|[12][0-9]|3[01])$/.test(day);
    })
    .test('is-year-field-valid', 'Invalid year. Please enter the correct year', value => {
        if (!value) return false;
        const parts = value.split('/');
        const year = parts?.[2];
        return /^(19|20)\d{2}$/.test(year);
    })
    .test('is-past-date', 'Date of birth must be in the past', value => {
        if (!value) return false;
        return dayjs(value, 'MM/DD/YYYY', true).isBefore(dayjs());
    })
    .test('is-18', 'You must be at least 18 years old to use MedBox.', value => {
        if (!value) return false;
        return dayjs(value, 'MM/DD/YYYY', true).add(18, 'years').isBefore(dayjs());
    });
